import { useContext } from 'react';
import { TranslationContext } from 'data/translation/context';
export type { TranslationContextType } from './context';

export const useTranslation = () => useContext(TranslationContext);
